import React from "react";
import Modal from "react-modal";
import "./UI_model_project.css";
import { SX_dashboard_UI_icon, SX_dashboard_UI_modal } from "../assets/icons";

Modal.setAppElement("#root");

export default function UI_Modal_project({
  isOpen,
  children,
  closeModal,
  title,
  styleTop,
  styleLeft,
  styleUnit,
}) {
  let styleModel = {
    content: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      height:
        title === "Forgot Password"
          ? "400px"
          : title === "Create Card Project"
          ? "47%"
          : "20%", // Add dynamic height for "Create Project"

      width:
        title === "Forgot Password"
          ? "650px"
          : window.innerWidth <= 1000
          ? "65%"
          : "24%",
      maxWidth: "75%",
      maxHeight: "75%",
      borderRadius: "1rem",
      outline: "1px solid #ffffffcc",
      padding: "10px",
      overflow: title === "Forgot Password" ? "hidden" : "auto",
    },
    overlay: { backgroundColor: "#1111138c", backdropFilter: "blur(8px)" },
  };

  if (styleTop) {
    styleModel.content.top = styleTop + (styleUnit || "%");
  }
  if (styleLeft) {
    styleModel.content.left = styleLeft + (styleUnit || "%");
  }

  return (
    <Modal
      isOpen={isOpen}
      style={styleModel}
      className="user_input_modal UI_model_project_resp drop-shadow-2xl flex justify-center items-center UI_modal_project"
    >
      {/* <div className="w-1/2 flex justify-center items-center p-[15px]">
        <img
          className="w-[90%] scale-[1.1] ml-[10px] rounded-2xl"
          src={SX_dashboard_UI_modal}
          alt=""
        />
      </div> */}
      <div className="rounded w-full flex flex-col items-center px-3">
        <div
          className=" flex justify-center items-center text-white"
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
           <div className=" flex flex-col items-center justify-center">
            {title === "Duplicated successfully" ? (
              <span className="manrope-600 text-[1.78rem] text-left text-white">
                Duplicated successfully
              </span>
            ) : title === "Project Created Successfully" ? (
              <span className="manrope-600 text-[1.78rem] text-left text-white">
                Project Created Successfully
              </span>
            ) : (
              <span className="manrope-600 text-[1.78rem] text-left text-white">
                {title}
              </span>
            )}
           
          </div>
       
        </div>
       
        <div>{children}</div>
      </div>
    </Modal>
  );
}
